const actionTypes = {};

actionTypes.ADD_TO_CART = "shopping/add_to_cart";
actionTypes.REMOVE_TO_CART = "shopping/remove_to_cart";
actionTypes.QTY_INCREASE = "shopping/qty_increase";
actionTypes.QTY_DECREASE = "shopping/qth_decrease";

export default actionTypes;
